import { useContext } from 'react';

import AutoAzimuthRotation from '@/components/game/3d/animation/AutoAzimuthRotation';
import DiscardPileBuilderAnimated from '@/components/game/3d/builder/card/DiscardPileBuilderAnimated';
import NewsCardBuilder from '@/components/game/3d/builder/card/NewsCardBuilder';
import SummitWinnerBuilder from '@/components/game/3d/builder/piece/SummitWinnerBuilder';
import PlayermatBuilder from '@/components/game/3d/builder/PlayermatBuilder';
import Rulesmat from '@/components/game/3d/object/Rulesmat';
import SeasonWindow from '@/components/game/3d/object/SeasonWindow';
import Table from '@/components/game/3d/object/Table';
import PhysicsFloor from '@/components/game/3d/physics/PhysicsFloor';
import { GameContext } from '@/state/contexts';
import { useTutorial } from '@/hooks/useTutorial';
import { tutStep_4 } from '@/lyoc-common/src/const/tutorial';

/**
 * Each player will have their mat be "front facing"
 * below WEP, CR, Rules mat
 */
const TableBuilder = ({ camState, viewNewsCards }) => {
	const { currPlayer, playerStateArray }: any = useContext(GameContext); // numPlayers, monthTracker, seasonTracker, carbonReservoir,

	const { tutorialCheck } = useTutorial();

	// I AM IN FRONT OF TABLE, all players wrap around me based on said turn order
	// get my color in turn order, push series of playermats with rotation of Math.PI * .5 * i
	function tableContents() {
		let matArray: Array<any> = [];

		/*
      1) player order is shuffled on game start
      2) iterate through player order id (0-2 or 0-3) to create an array of colors matching current player order
      3) set textures to mat via this player order
    */
		let colorToMat = ['yellow', 'blue', 'red', 'green'];

		function getMatPathId(color) {
			for (let i = 0; i < 4; i++) {
				if (colorToMat[i] === color) {
					return i;
				}
			}
		}

		if (playerStateArray) {
			for (let i = 0; i < playerStateArray.length; i++) {
				const matPathId = getMatPathId(playerStateArray[i].color);
				matArray.push(
					<PlayermatBuilder
						key={'mat' + playerStateArray[i].playerId}
						playerId={playerStateArray[i].playerId}
						rotato={
							Math.PI *
							(0.5 *
								(playerStateArray[i].playerId -
									currPlayer?.playerId || 0))
						}
						matColor={playerStateArray[i].color}
						matPathId={matPathId}
					/>
				);
			}
		}

		return (
			<group position={[-20, -21, -20]}>
				<Table />
				{tutorialCheck(tutStep_4) && (
					<>
						<PhysicsFloor>
							<Rulesmat />
						</PhysicsFloor>
						<SeasonWindow />
						<SummitWinnerBuilder />
						<DiscardPileBuilderAnimated />
						<NewsCardBuilder viewNewsCards={viewNewsCards} />
					</>
				)}
				{playerStateArray.length > 0 && matArray}
			</group>
		);
	}

	// TODO swap this with changing the camera's position, not creating a new presentationcontrols component.
	// ADD a payment view, up close for stuff
	// would be cool for a UI/3d model to show you what you're paying for. Can be as simple as a slab for now

	// enable free rotation, lock camera movement and position when paying for stuff

	// set paymentMode to default false

	// when paying for something, set paymentMode to true
	// update camera position
	// have an indicator of what you're paying for and the cost
	// add cancel and pay buttons

	if (camState === 'spin') {
		return (
			<AutoAzimuthRotation speed={0.6}>
				<group position={[20, 16, 20]}>{tableContents()}</group>
			</AutoAzimuthRotation>
		);
	}

	return <group position={[20, 16, 20]}>{tableContents()}</group>;
};

export default TableBuilder;
